import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-representante-succes',
    templateUrl: '../../components/view-succes/view-succes.component.html',
    styleUrls: ['../../components/view-succes/view-succes.component.css'],
})
export class ViewRepresentanteComponent {
    mensaje: string;
    displeyIdl = false;
    nombreBtn = 'Continuar';
    constructor(private readonly router: Router) {}

    public continuar() {
        this.router.navigate(['inicio']);
        this.displeyIdl = false;
    }
    mostrar(mensaje: string) {
        this.mensaje = mensaje;
        this.displeyIdl = true;
    }
}
